import(/* webpackMode: "eager" */ "/home/ubuntu/vc_fullfillment/apps/web/src/app/global-error.tsx");
